import { useCategoryCatalog } from '../../../../hooks/useCategoryCatalog.js';
import { buildCategoryRows } from '../../utils/teamLoads.js';
import TeamLoadCard from './TeamLoadCard.jsx';

const EMPTY_LOAD = { tasksLoad: 0, loadByCategory: {} };

/**
 * Banda de resumen del dia: una card por columna de equipo, alineada con la grilla
 * porque recibe el mismo gridTemplateColumns que usan la cabecera y el cuerpo.
 *
 * Es presentacional: los datos y su ciclo de carga viven en TasksCalendarView.
 */
const TeamLoadsBand = ({
  visibleTeams,
  gridTemplateColumns,
  loadsByTeamId,
  isDetailExpanded = true,
  loading,
  error,
  onRetry,
}) => {
  // El catalogo no bloquea el render: si no llego o fallo, los nombres caen al identificador
  const categoryCatalog = useCategoryCatalog();

  // El fallo se muestra aca dentro y no degrada la grilla del dia
  if (error) {
    return (
      <div
        id="team-loads-band"
        className="flex flex-wrap items-center gap-3 border-b border-line bg-table-head px-4 py-4 text-sm text-content-muted"
      >
        <span>No se pudo cargar el resumen por equipo.</span>
        <button
          type="button"
          onClick={onRetry}
          className="rounded-lg border border-line bg-surface-2 px-3 py-1.5 text-xs font-medium text-content transition-colors hover:bg-line"
        >
          Reintentar
        </button>
      </div>
    );
  }

  // El placeholder replica la estructura de la card para no desplazar la grilla al llegar los datos
  if (loading) {
    return (
      <div
        id="team-loads-band"
        aria-busy="true"
        className="grid gap-px border-b border-line bg-line"
        style={{ gridTemplateColumns }}
      >
        {visibleTeams.map((team) => (
          <div key={team.id} className="min-w-0 animate-pulse bg-surface px-4 pb-4 pt-3">
            <div className="mb-2 h-3 w-2/3 rounded bg-surface-2" />
            <div className={`h-7 w-16 rounded bg-surface-2 ${isDetailExpanded ? 'mb-3' : ''}`} />
            {isDetailExpanded && (
              <div className="space-y-[5px] border-t border-dashed border-line pt-2">
                <div className="h-3 w-full rounded bg-surface-2" />
                <div className="h-3 w-full rounded bg-surface-2" />
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      id="team-loads-band"
      className="grid gap-px border-b border-line bg-line"
      style={{ gridTemplateColumns }}
    >
      {visibleTeams.map((team) => {
        // Un equipo ausente en la respuesta vale 0, no es un error
        const load = loadsByTeamId[team.id] || EMPTY_LOAD;
        const categoryRows = buildCategoryRows(load.loadByCategory, load.tasksLoad, categoryCatalog);

        return (
          <TeamLoadCard
            key={team.id}
            teamName={team.name}
            tasksLoad={load.tasksLoad}
            categoryRows={isDetailExpanded ? categoryRows : []}
          />
        );
      })}
    </div>
  );
};

export default TeamLoadsBand;
